/**
 * /*
 *
 * @format
 * @Description:
 * @Author: changfu
 * @Date: 2020-06-12 09:19:19
 * @LastEditTime: 2020-06-12 09:19:20
 * @LastEditors:
 */
export default {
  logLogin: {
    userName: '用户名',
    loginLime: '登入时间',
    logList: '日志列表',
    ipAddres: 'IP地址',
    loginApplication: '登陆应用',
    exitTime: '登出时间',
    tenant: '所属租户'
  }
};



// WEBPACK FOOTER //
// ./src/config/langs/zh_CN/logLogin.js